import { useState, type ReactNode } from 'react';
import './admin.css';

interface AdminShellProps {
  title: string;
  onBack: () => void;
  actions?: ReactNode;
  children: ReactNode;
  modal?: boolean;
}

export default function AdminShell({ title, onBack, actions, children, modal = false }: AdminShellProps) {
  // Окно урока/теста можно развернуть на весь экран и свернуть обратно (просьба владельца 09.09.2026).
  // Выбор запоминается: у кого большой монитор, тому каждый раз разворачивать не нужно.
  const [wide, setWide] = useState(() => {
    try { return localStorage.getItem('beshek_admin_wide') === '1'; } catch { return false; }
  });
  const toggleWide = () => setWide(v => {
    try { localStorage.setItem('beshek_admin_wide', v ? '0' : '1'); } catch { /* нет localStorage */ }
    return !v;
  });
  const modalBox = wide
    ? 'w-[98vw] max-w-none h-[96dvh] overflow-y-auto rounded-2xl border border-[#E1E5E3] bg-white shadow-lg'
    : 'w-full max-w-[1100px] max-h-[94dvh] overflow-y-auto rounded-2xl border border-[#E1E5E3] bg-white shadow-lg';
  return (
    <div role={modal ? 'dialog' : undefined} aria-modal={modal || undefined} aria-label={modal ? title : undefined} className={`admin-theme text-[#252A2D] ${modal && wide ? 'admin-wide ' : ''}${modal ? modalBox : 'min-h-screen bg-[#F7F7F4]'}`}>
      <header className="sticky top-0 z-20 border-b border-[#E1E5E3] bg-white">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-6 py-3">
          <div className="min-w-0 flex-1">
            <button type="button" onClick={onBack} className="text-sm text-[#0F766E] hover:text-[#0B5F59]">← Назад</button>
            <h1 className="break-words text-lg font-semibold sm:text-xl">{title}</h1>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {modal && (
              <button type="button" onClick={toggleWide} title={wide ? 'Свернуть окно' : 'Развернуть на весь экран'}
                className="hidden rounded-lg border border-[#E1E5E3] px-3 py-2 text-sm text-[#252A2D] hover:bg-[#E5F2EF] lg:inline-block">
                {wide ? '⤡ Свернуть' : '⤢ Развернуть'}
              </button>
            )}
            {actions}
          </div>
        </div>
      </header>
      <div className={`mx-auto px-6 py-6 ${modal && wide ? 'max-w-none' : 'max-w-[1400px]'}`}>{children}</div>
    </div>
  );
}
